import React from 'react';
import { Outlet } from 'react-router-dom';
import { TopSideFooter } from '@zurich-base-ui/layout.top-side-footer';
import {
  TopNav,
  SupportSideNav,
  BetaWelcome,
  BetaButton
} from 'app/components';
import styles from './Layout.module.scss';

const Support: React.FC = () => {
  return (
    <TopSideFooter>
      <TopSideFooter.TopBar>
        <TopNav />
      </TopSideFooter.TopBar>
      <TopSideFooter.Main>
        <div className={styles.support}>
          <SupportSideNav />
          <Outlet />
          <BetaWelcome />
          <BetaButton />
        </div>
      </TopSideFooter.Main>
    </TopSideFooter>
  );
};

export default Support;
